module.exports = __webpack_public_path__ + "img/benoit7.195f5e60.jpg";